import React from "react"
import {
    RecoilRoot,
  } from 'recoil';

export default ({ element }) => (
    <RecoilRoot>{element}</RecoilRoot>
)  